module.exports = __webpack_public_path__ + "img/icon-resize.a3d4af3d.svg";